var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.SalesMaximumQuantity.title")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Code,
                                    "text",
                                    "get.SalesMaximumQuantity.Code"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.StatusId
                                      ? _vm.$t("insert.active")
                                      : _vm.$t("insert.passive"),
                                    "text",
                                    "get.SalesMaximumQuantity.StatusId"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Description1,
                                    "text",
                                    "get.Description1.Code"
                                  )
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.BeginDate,
                                    "date",
                                    "get.SalesMaximumQuantity.BeginDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.EndDate,
                                    "date",
                                    "get.SalesMaximumQuantity.BeginDate"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.SalesMaximumQuantity.CustomerList")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("b-table", {
                                  attrs: {
                                    items:
                                      _vm.rowData.SalesMaximumQuantityCustomers,
                                    fields: _vm.fields,
                                    "current-page":
                                      _vm.SalesMaximumQuantityCustomersCurrentPage,
                                    "per-page": _vm.perPage,
                                    small: "",
                                    bordered: "",
                                    responsive: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows":
                                      _vm.rowData.SalesMaximumQuantityCustomers
                                        .length,
                                    "per-page": _vm.perPage
                                  },
                                  model: {
                                    value:
                                      _vm.SalesMaximumQuantityCustomersCurrentPage,
                                    callback: function($$v) {
                                      _vm.SalesMaximumQuantityCustomersCurrentPage = $$v
                                    },
                                    expression:
                                      "SalesMaximumQuantityCustomersCurrentPage"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27a891ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a891ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SalesMaximumQuantity/get.vue
// module id = null
// module chunks = 